import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Slider from './Slider';
import './VideoPlayer.css';
import Urls from '../urls/Urls';
import TemporalCallback from '../core/TemporalCallback';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
import ProgressBar from '../views/ProgressBar';
import ResizeWatcher from '../ui_core/ResizeWatcher';
import EfficientMoveCycle from '../ui_core/EfficientMoveCycle';
import IconButtonNonReact from '../components/IconButtonNonReact';
import FrequencyLimitedCallback from '../core/FrequencyLimitedCallback';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import ClickedOff from '../ui_core/ClickedOff';
export default class VideoPlayer {
	constructor(props){
		const {maximized, closeable,  toggleMaximizeButton, forceFillWidth}=props;
		this._forceFillWidth = forceFillWidth;
		this._maximized = maximized;
		this.load = this.load.bind(this);
		this.play = this.play.bind(this);
		this.stop = this.stop.bind(this);
		this.hide = this.hide.bind(this);
		this._setVisible = this._setVisible.bind(this);
		this._setPlayButtonImage = this._setPlayButtonImage.bind(this);	
		this._clickedPlayStopButton = this._clickedPlayStopButton.bind(this);
		this._updateFillWidthHeight = this._updateFillWidthHeight.bind(this);
		this._startedTouchForwardReverse = this._startedTouchForwardReverse.bind(this);
		this._moveTouchForwardReverse = this._moveTouchForwardReverse.bind(this);
		this._onVolumeSliderValueChanged = this._onVolumeSliderValueChanged.bind(this);
		this._setVolumeVisible = this._setVolumeVisible.bind(this);
		this._hideVolume = this._hideVolume.bind(this);
		this._mouseActive = this._mouseActive.bind(this);
		this._showUI = this._showUI.bind(this);
		this._hideUI = this._hideUI.bind(this);
		this._onVideoTimeUpdate = this._onVideoTimeUpdate.bind(this);
		this._handleClickButtonFullscreen = this._handleClickButtonFullscreen.bind(this);
		this._videoEnded = this._videoEnded.bind(this);
		this._setVideoTimeFromTouchForwardReverseDistance = this._setVideoTimeFromTouchForwardReverseDistance.bind(this);
		this._endTouchForwardReverse = this._endTouchForwardReverse.bind(this);
		this._clickedProgressBar = this._clickedProgressBar.bind(this);
		this._updateMaximized = this._updateMaximized.bind(this);
		this._setHasVideo = this._setHasVideo.bind(this);
		this._showVolume = this._showVolume.bind(this);
		this._toggleVolume = this._toggleVolume.bind(this);
		
		this._element = document.createElement('div');
		this._element.classList.add('video-player');
		this._videoElement = document.createElement('video');
		this._volumeWrapperElement = document.createElement('div');
		this._volumeWrapperElement.classList.add('volume-wrapper');
		this._volumeWrapperInnerElement = document.createElement('div');
		this._volumeWrapperInnerElement.classList.add('volume-wrapper-inner');
		this._videoWrapperElement = document.createElement('div');
		this._videoWrapperElement.appendChild(this._volumeWrapperElement);
		this._videoWrapperElement.classList.add('video-wrapper');
		this._element.appendChild(this._videoWrapperElement);
		this._videoWrapperElement.appendChild(this._videoElement);
		this._buttonPlayPause = document.createElement('button');
		this._buttonPlayPause.classList.add('button-play-pause');
		this._imgPlayPause = document.createElement('img');
		this._buttonPlayPause.appendChild(this._imgPlayPause);
		this._element.appendChild(this._buttonPlayPause);
		this._playing  = false;
		this._buttonPlayPause.addEventListener('click', this._clickedPlayStopButton);
		this._element.addEventListener('mousemove', this._mouseActive);
		
		if(closeable){
			this._iconButtonNonReactClose = new IconButtonNonReact({imgUrl:Urls.assets+'icons/UI_Button_Exit.png', className:'button-close', onClick:this.hide});
			this._element.appendChild(this._iconButtonNonReactClose.element);
		}
				
		this.__uiVisible = false;
		exposeBinding(this, '_uiVisible', ()=>this._uiVisible, (value)=>this._uiVisible = value);
		exposeBinding(this, '_proportion', ()=>this._proportion, (value)=>this._proportion = value);
		this._progressBar =  new ProgressBar({propertyNameProgressProportion:'_proportion', propertyNameVisible:'_uiVisible', delayHide:false, model:this,
			clickEvent:true});
			this._progressBar.addEventListener('clicked', this._clickedProgressBar);
		this._temporalCallbackHideUI = new TemporalCallback({callback:this._hideUI, delay:2000});
		this._videoWrapperElement.appendChild(this._progressBar.element);
		this._resizeWatcher = new ResizeWatcher({element:this._element, onResized:this._updateFillWidthHeight});
		this._videoElement.addEventListener('timeupdate', this._onVideoTimeUpdate, false);
		this._videoElement.addEventListener('ended', this._videoEnded, false);
		this._efficientMoveCycleTouchForwardReverse = new EfficientMoveCycle({
			element:this._videoElement, stopPropagation:false, preventDefault:true,
			onStart:this._startedTouchForwardReverse, onMove:this._moveTouchForwardReverse, 
			onEnd:this._endTouchForwardReverse, friendlyXY:true});
		this._frequencyLimitedCallbackTouchForwardReverse = new FrequencyLimitedCallback({frequencyHz:4});
		this._updateMaximized();
		this._setHasVideo(false);
		this._iconButtonVolume = new IconButtonNonReact({
			className:"button-volume",
			imgUrl:Urls.assets+'icons/Volume.png',
			onClick:this._toggleVolume});
		this._videoWrapperElement.appendChild(this._iconButtonVolume.element);
		if(toggleMaximizeButton){
			
			this._iconButtonFullScreen = new IconButtonNonReact({
				className:"button-fullscreen",
				imgUrl:Urls.assets+'icons/UI_Fullscreen.png',
				onClick:this._handleClickButtonFullscreen});
			this._videoWrapperElement.appendChild(this._iconButtonFullScreen.element);
		}
		this._volumeSliderRef = React.createRef();
		const sliderFactory = React.createFactory(Slider);
		this._volumeWrapperElement.appendChild(this._volumeWrapperInnerElement);
		ReactDOM.render(sliderFactory(
			{ 
				ref:this._volumeSliderRef, 
				min:0, max:1, initial:0, 
				onValueChanged:this._onVolumeSliderValueChanged, 
				isHorizontal:false
			}),
			this._volumeWrapperInnerElement);
		this._clickedOffManager = new ClickedOffManager({
			element:this._volumeWrapperElement, 
			hide:this._hideVolume});
		
	}
	_toggleVolume(){
		if(this._volumeShowing)
			this._hideVolume();
		else 
			this._showVolume();
	}
	_showVolume(){
		this._clickedOffVolumeHandle&&this._clickedOffVolumeHandle.dispose();
		this._clickedOffVolumeHandle = this._clickedOffManager.register();
		this._setVolumeVisible(true);
	}
	_hideVolume(){
		this._clickedOffVolumeHandle&&this._clickedOffVolumeHandle.dispose();
		this._setVolumeVisible(false);
	}
	_setVolumeVisible(value){
		if(value)
			this._volumeWrapperElement.classList.add('visible');
		else 
			this._volumeWrapperElement.classList.remove('visible');
		this._volumeShowing= value;
	}
	_onVolumeSliderValueChanged(e){
		const proportionVolume = 1-e;
		this._videoElement.volume=proportionVolume;
	}
	_setHasVideo(value){
		if(value)
			this._element.classList.add('has-video');
		else 
			this._element.classList.remove('has-video');
	}
	_handleClickButtonFullscreen(){
		this._maximized = !this._maximized;
		this._updateMaximized();
	}
	_updateMaximized(){
		
		if(this._maximized)
			this._element.classList.add('maximized');
		else 
			this._element.classList.remove('maximized');
	}
	get element(){
		return this._element;
	}
	_clickedProgressBar(e){
		this._videoElement.currentTime = e.proportion*this._videoElement.duration
	}
	_startedTouchForwardReverse(e){
		this._touchDownNotCancelledYet = true;
		this._hideUISuspended = true;
		this._startTouchPosition = [e.x, e.y];
		this._videoProportionAtStartOfTouch = this._videoElement.currentTime/ this._videoElement.duration;
	}
	_moveTouchForwardReverse(e){
		this._touchDownNotCancelledYet = false;
		const distanceX = e.x - this._startTouchPosition[0];
		this._frequencyLimitedCallbackTouchForwardReverse.trigger(()=>this._setVideoTimeFromTouchForwardReverseDistance(distanceX));
	}
	_setVideoTimeFromTouchForwardReverseDistance(distanceX){
		const dProportion = distanceX / this._videoElement.offsetWidth;
		let newProportion = (this._videoProportionAtStartOfTouch+dProportion);
		if(newProportion>1)newProportion = 1;
		else if(newProportion<0)newProportion = 0;
		this._videoElement.currentTime = newProportion*this._videoElement.duration;
	}
	_endTouchForwardReverse(e){
		this._hideUISuspended = false;
		if(this._touchDownNotCancelledYet){
			if(!this._volumeShowing)
				this._clickedPlayStopButton();
			ClickedOff.triggerClicked(e);
		}
		this._temporalCallbackHideUI.trigger();

	}
	_updateFillWidthHeight(){
		const videoAspectRatio = this._videoElement.videoWidth/this._videoElement.videoHeight;
		const elementAspectRatio = this._element.offsetWidth/this._element.offsetHeight;
		const fillHeight = (!this._forceFillWidth|this._maximized)&&videoAspectRatio<=elementAspectRatio;
		if(fillHeight)this._element.classList.add('fill-height');
		else this._element.classList.remove('fill-height');
	}
	get _uiVisible(){
		return this.__uiVisible;
	}
	set _uiVisible(value){
		if(this.__uiVisible===value)return;
		this.__uiVisible = value;
		this.bindingsHandler.changed('_uiVisible', this.__uiVisible);
		if(value)this._element.classList.add('ui-visible');
		else this._element.classList.remove('ui-visible');
	}
	get _proportion(){
		return this.__proportion;
	}
	set _proportion(value){
		if(this.__proportion===value)return;
		this.__proportion = value;
		this.bindingsHandler.changed('_proportion', this.__proportion);
	}
	_mouseActive(){
		this._showUI();
	}
	_showUI(){
		this._uiVisible = true;
		setTimeout(this._updateFillWidthHeight, 0);
		this._temporalCallbackHideUI.trigger();
	}
	_hideUI(){
		if(this._hideUISuspended)return;
		this._uiVisible = false;
	}
	_clickedPlayStopButton(){
		if(!this._uiVisible)return;
		if(this._playing)
			this.stop();
		else this._play();
	}
	play({url}){
		this._setVisible(true);
		this._setHasVideo(url?true:false);
		this._videoElement.src = url;
		this._play();
	}
	load({url}){
		this._setVisible(true);
		this._setHasVideo(url?true:false);
		this._videoElement.src = url;
		this._setPlayButtonImage();
	}
	_play(){
		this._videoElement.play();
		this._playing = true;
		this._setPlayButtonImage();
	}
	stop(){
		this._videoElement.pause();
		this._playing = false;
		this._setPlayButtonImage();
	}
	hide(){
		this.stop();
		this._setVisible(false);
	}
	_setPlayButtonImage(playing){
		this._imgPlayPause.src= this._playing?(Urls.assets+'icons/UI_Button_Pause.png'):(
			Urls.assets+'icons/UI_Button_Play.png'
		);
	}
	_setVisible(value){
		if(value)
			this._element.classList.add('visible');
		else
			this._element.classList.remove('visible');
	}
	_onVideoTimeUpdate(e){
		const video = this._videoElement;
		const proportion =  video.currentTime/ video.duration;
		this._proportion= proportion;
	}
    _videoEnded(e) {
		this.stop();
		this._videoElement.currentTime=0;
    }
}
